<template>
  <div class="popup" :style="pStyle">
    <div class="popup-title">
      <span>
        {{ title }}
      </span>
      <button class="btn btn-common" @click.stop="close">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.35355 1.64645C2.15829 1.45118 1.84171 1.45118 1.64645 1.64645C1.45118 1.84171 1.45118 2.15829 1.64645 2.35355L7.29289 8L1.64645 13.6464C1.45118 13.8417 1.45118 14.1583 1.64645 14.3536C1.84171 14.5488 2.15829 14.5488 2.35355 14.3536L8 8.70711L13.6464 14.3536C13.8417 14.5488 14.1583 14.5488 14.3536 14.3536C14.5488 14.1583 14.5488 13.8417 14.3536 13.6464L8.70711 8L14.3536 2.35355C14.5488 2.15829 14.5488 1.84171 14.3536 1.64645C14.1583 1.45118 13.8417 1.45118 13.6464 1.64645L8 7.29289L2.35355 1.64645Z"
            fill="#E2E2E2" />
        </svg>
      </button>
    </div>
    <div class="popup-content">
      {{ content }}
    </div>
    <div v-if="styleArrow" class="arrow" :style="styleArrow">
      <svg
        style="display: inline; vertical-align: unset"
        width="8"
        height="16"
        viewBox="0 0 8 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8 0L8 8L8 16L0.707106 8.70711C0.316581 8.31658 0.316582 7.68342 0.707106 7.29289L8 0Z"
          fill="#323232" />
      </svg>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { app } from '@/store';
import { cloneDeep } from '@/utils/common';

export default {
  name: 'PopupOnBoarding',
  props: {
    title: {
      type: String,
    },
    content: {
      type: String,
    },
    pStyle: {
      type: Object,
    },
    styleArrow: {
      type: Object,
    },
    typeOB: {
      type: String,
    },
  },
  computed: {
    ...mapState('app', {
      shopMeta: 'shopMeta',
    }),
    obGlobalStyle() {
      return this.shopMeta.onboardingGlobalStyle;
    },
  },
  created() {
    this.handleCreated();
  },
  unmounted() {
    this.handleDestroy();
  },
  methods: {
    ...mapActions('app', {
      updateShopMeta: 'updateShopMeta',
    }),
    handleCreated() {
      const payload = cloneDeep(this.shopMeta);

      if (this.typeOB === 'previewPreset') {
        payload.onboardingGlobalStyle.previewPreset = true;
      } else if (this.typeOB === 'previewMode') {
        payload.onboardingGlobalStyle.previewMode = true;
      } else if (this.typeOB === 'applyPreset') {
        payload.onboardingGlobalStyle.applyPreset = true;
      } else if (this.typeOB === 'firstSavePreset') {
        payload.onboardingGlobalStyle.savePreset = true;
        payload.onboardingGlobalStyle.firstSavePreset = true;
      } else if (this.typeOB === 'createNewPreset') {
        payload.onboardingGlobalStyle.createNewPreset = true;
      } else if (this.typeOB === 'publicPreset') {
        payload.onboardingGlobalStyle.publicPreset = true;
      }

      this.updateShopMeta(payload);
    },

    handleDestroy() {
      const shopMeta = app.$store.state['app']['shopMeta'];
      if (this.typeOB === 'previewPreset') {
        shopMeta['onboardingGlobalStyle']['previewPreset'] = true;
      } else if (this.typeOB === 'previewMode') {
        shopMeta['onboardingGlobalStyle']['previewMode'] = true;
      } else if (this.typeOB === 'applyPreset') {
        shopMeta['onboardingGlobalStyle']['applyPreset'] = true;
      } else if (this.typeOB === 'firstSavePreset') {
        shopMeta['onboardingGlobalStyle']['firstSavePreset'] = true;
        shopMeta['onboardingGlobalStyle']['savePreset'] = true;
      } else if (this.typeOB === 'createNewPreset') {
        shopMeta['onboardingGlobalStyle']['createNewPreset'] = true;
      } else if (this.typeOB === 'publicPreset') {
        shopMeta['onboardingGlobalStyle']['publicPreset'] = true;
      }
    },
    close() {
      this.handleDestroy();
    },
  },
};
</script>

<style lang="scss" scoped>
.popup {
  width: 294px;
  background: #323232;
  border-radius: 3px;
  z-index: 9;

  .btn-common {
    display: flex;
    background: none;
    top: 16px;
    right: 0;
  }

  &-title {
    color: #8aa4ff;
    font-size: 16px;
    line-height: 150%;
    font-style: normal;
    font-weight: 500;
    margin: 14px 0 8px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &-content {
    color: #e2e2e2;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    margin: 0 16px 16px 16px;
  }
}
</style>
